import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH CONFIGURATION ********************
export const fetchConfiguration = () => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_CONFIGURATION_LOADING,
			payload: true
		});

		const response = await services.get(`/settings`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_CONFIGURATION_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		console.error(error);
		dispatch({
			type: types.FETCH_CONFIGURATION_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
